module.exports = __webpack_public_path__ + "img/banner@2x.d8b6baeb.png";